<template>
  <Modal
    :title="$t('create_vat_group')"
    modalId="create-modal"
    @submit="submitVatGroup"
    @cancel="resetForm"
  >
    <form @submit.prevent="submitVatGroup">
      <div class="mb-3">
        <label class="form-label">
          {{ $t('vat_group_name') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="vatGroup.vat_group_name"
          class="form-control"
        />
        <div v-if="errors.vat_group_name" class="text-danger mt-2">
          <span>{{ errors.vat_group_name }}</span>
        </div>
      </div>

      <div class="mb-3">
        <label class="form-label">
          {{ $t('vat_value') }} <span class="text-danger">*</span>
        </label>
        <input
          type="text"
          v-model="vatGroup.vat_value"
          class="form-control"
        />
        <div v-if="errors.vat_value" class="text-danger mt-2">
          <span>{{ errors.vat_value }}</span>
        </div>
      </div>
      <div v-if="errorMessage" class="text-danger mt-2">
        {{ errorMessage }}
      </div>
    </form>
  </Modal>
</template>

<script>
import Modal from "@/components/common/Modal.vue"; // Import Modal component
import apiUrls from "../../../urls";
import {useToast} from "vue-toastification";

export default {
   components: {
      Modal,
    },

   data() {
    return {
      vatGroup: {
        vat_group_name: '',
        vat_value: '',
      },
      errors: {},
      errorMessage: "",
    };
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  methods: {
      async submitVatGroup() {
        // Frontend validation before making API call
          this.errors = {};
          if (!this.vatGroup.vat_group_name) this.errors.color = this.$t('error.required');
          if (!this.vatGroup.vat_value) this.errors.color = this.$t('error.required');

          if (Object.keys(this.errors).length > 0) {
          return; // Stop execution if validation fails
        }

        try {
          const formData = new FormData();
          Object.keys(this.vatGroup).forEach((key) => {
            formData.append(key, this.vatGroup[key]);
          });
          // Send API request
          const response = await this.$axios.post(apiUrls.vat_group.post, formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.toast.success('Vat group successfully created!')

          // Close modal after success
          const modal = document.getElementById("create-modal");
          const modalInstance = bootstrap.Modal.getInstance(modal);
          if (modalInstance) modalInstance.hide();

          // Emit event to update parent component
          this.$emit("create_success");

          this.resetForm();
        } catch (error) {
          if (error.response?.data?.error) {
            this.errorMessage = error.response.data.error;
          }

          // Handle field-specific errors dynamically
          if (error.response?.data?.errors) {
            this.errors = error.response.data.errors; // Dynamically set field errors
          }
        }
      },
      resetForm() {
      // Reset form fields and errors
      this.vatGroup.vat_group_name = "";
      this.vatGroup.vat_value = "";
      this.errors = {};
      this.errorMessage = "";
    }
  },
};
</script>
